import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7b827a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Nueva Factura", -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "idfact"
}, "Id:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "id_ars"
}, "Id ARS:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nom"
}, "Paciente:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nro_autorizacion_salida"
}, "Autorización:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fecha"
}, "Fecha / Hora:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "numero_afiliado"
}, "Afiliado No.:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "rnc"
}, "Cédula:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_factura"
}, "Orígen:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cobertura"
}, "Cobertura:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "total_empleado"
}, "Total:", -1))
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", {
            class: _normalizeClass(_ctx.isError(_ctx.error))
          }, _toDisplayString(_ctx.error), 3),
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                      id: "idfact",
                      type: "idfact",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.factura.idfact) = $event)),
                      class: "form-control",
                      onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.getFactura()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.factura.idfact]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("input", {
                      id: "id_ars",
                      type: "id_ars",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.factura.id_ars) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.id_ars]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      id: "nom",
                      type: "nom",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.factura.nom) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.nom]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                      id: "nro_autorizacion_salida",
                      type: "nro_autorizacion_salida",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.factura.nro_autorizacion_salida) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.nro_autorizacion_salida]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      id: "fecha",
                      type: "datetime-local",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.factura.fecha) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.fecha]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      id: "numero_afiliado",
                      type: "numero_afiliado",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.factura.numero_afiliado) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.numero_afiliado]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      id: "rnc",
                      type: "rnc",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.factura.rnc) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.rnc]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      id: "tipo_factura",
                      type: "tipo_factura",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.factura.tipo_factura) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.tipo_factura]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      id: "cobertura",
                      type: "number",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.factura.cobertura) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.cobertura]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                      id: "total_empleado",
                      type: "number",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.factura.total_empleado) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.factura.total_empleado]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.saveFactura()), ["prevent"])),
                disabled: 
              !_ctx.factura.idfact ||
                !_ctx.factura.id_ars ||
                !_ctx.factura.nom ||
                !_ctx.factura.nro_autorizacion_salida ||
                !_ctx.factura.fecha ||
                !_ctx.factura.numero_afiliado ||
                !_ctx.factura.rnc ||
                !_ctx.factura.tipo_factura ||
                !_ctx.factura.cobertura
            
              }, " Guardar ", 8, _hoisted_18)
            ])
          ])
        ], 512), [
          [_vShow, !_ctx.cargando]
        ])
      ]),
      _: 1
    })
  ], 64))
}